import { createSlice } from '@reduxjs/toolkit';

const notifSlice = createSlice({
  name: 'notification',
  initialState: {
    notification: [
      {
        from: 'Halley Team',
        text: 'Please check your notifications!',
        date: '8/11/2024 17:58',
        to: 'All User',
      },
      {
        from: 'Halley Team',
        text: 'Hello, Welcome to our application.',
        date: '8/03/2024 22:01',
        to: 'All User',
      },
    ],
  },
});

export const notifAction = notifSlice.actions;

export default notifSlice;
